import { Paper, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import { ComponentType } from 'react';

interface FeatureCardProps {
  icon: string;
  text: string;
  variant?: 'horizontal' | 'vertical';
  withPaper?: boolean;
}

export const FeatureCard = ({ icon, text, variant = 'horizontal', withPaper = false }: FeatureCardProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const StackComponent: ComponentType<any> = withPaper ? Paper : Stack;
  
  return (
    <StackComponent
      direction={variant === 'horizontal' ? 'row' : 'column'}
      alignItems="center"
      justifyContent="center"
      spacing={{ xs: 1, sm: 2 }}
      sx={{
        width: '100%',
        maxWidth: { xs: '100%', sm: '300px' },
        ...(withPaper && { 
          p: { xs: 2, sm: 3 }, 
          borderRadius: 5, 
          boxShadow: 3,
          bgcolor: 'rgba(255, 255, 255, 0.1)',
          backdropFilter: 'blur(10px)'
        })
      }}
    >
      <img 
        src={icon} 
        alt="feature icon" 
        style={{ 
          width: isMobile ? '24px' : '30px', 
          height: isMobile ? '24px' : '30px' 
        }} 
      />
      <Typography 
        variant="subtitle1" 
        color="#e0e0e0" 
        gutterBottom 
        sx={{ 
          fontSize: { xs: 14, sm: 16, md: 18 },
          textAlign: { xs: 'center', sm: 'left' },
          lineHeight: 1.4
        }}
      >
        {text}
      </Typography>
    </StackComponent>
  );
}; 